const radii: { [key: string]: string } = {
  small: '4px',
  normal: '8px',
  large: '16px',
};

export default radii;
